export default __webpack_public_path__ + "static/media/profile-placeholder.5b5faf9b.svg";